// Components
import Section from "./Section";

const SectionContainer = (props) => {
    return <Section {...props} />;
};

export default SectionContainer;
